import React from "react";

import Grid from "@material-ui/core/Grid";

import ChartSelectQuestion from "../../../../question/ChartSelectQuestion";

const CustodianStep = props => {
  const {
    onAnswerChange,
    questions: [
      depotsQuestion
    ],
    dataService
  } = props;

  const [, forceRender] = React.useState(0);

  React.useEffect(() => {
    dataService.initCustodianChoices(depotsQuestion);

    // workaround to force component re-render with new options
    forceRender((prev) => prev + 1)
  }, []);

  return (
    <Grid container spacing={2}>
      <ChartSelectQuestion
        question={depotsQuestion}
        dataService={dataService}
        onAnswerChange={onAnswerChange}
      />
    </Grid>
  );
};

export default CustodianStep;
